import { createWebHistory, createRouter } from "vue-router";

const routes =  [
  {
    path: "/",
    name: "detailsPage",
    component: () => import("./components/DetailsPage")
  },
   {
    path: "/more",
    name: "bill-more",
    component: () => import("./components/DetailsPage"),
    props: route => ({ mode: "more", ...route.query })
  }
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;